<template>
	<!-- Modal -->
	<div>
		<b-modal
			v-model="showModal"
			title="Grid Layout Example"
			id="basicdetailsFull"
			centered
			hide-footer
			hide-header
			:backdrop-class="computedBackdropClass"
			no-close-on-backdrop
			@hide="onModalHidden"
		>
			<div class="d-flex w-100">
				<div class="candash-modal-left width-5"></div>
				<div class="w95">
					<div class="candash-modal-top px-3 py-2">
						<div class="width-97 ml-1">
							<div class="candash-modal-head">Personal Details</div>
							<div class="candash-desc">Fill in your personal details</div>
						</div>
						<div
							v-if="formType == 'edit'"
							@mouseenter="checkForChanges()"
							@click="
								// $emit('close-modal', 'showBasicModalFullNew', isImageChanged)
								changesDetected ? $emit('discard-modal') : $emit('close-modal')
							"
							class="d-flex justify-content-end pointer"
						>
							<img
								class="rotate-on-hover"
								src="@/assets/newdesign/dashboard/blueCross.svg"
								alt=""
							/>
						</div>
					</div>
					<div class="candash-modal-body-11" v-if="formShimmer">
						<FormShimmer
							:shimmer="10"
							:from="'home'"
							:type="'laptop'"
							:formID="formID"
						/>
					</div>
					<div class="candash-modal-body-11" v-else>
						<div class="grid-container">
							<div
								class="grid-item position-relative"
								:class="`item` + (parseInt(index) + 1)"
								v-for="(field, index) in basicArray"
								:key="field.key"
								v-show="!field.hide"
							>
								<div
									v-if="
										field.controlType == 'upload_file' && field.key == 'image'
									"
									class="topDiv d-flex justify-content-center"
								>
									<ProfilePictureUpload
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										@select-value="updateFieldValue(field, $event)"
										:newObject="newObject"
										@updateImage="setUpdateValue($event)"
										@remove-image="setRemovedImg($event)"
										:checImgPath="candidateInfo.imagePath"
										:isLaptop="isLaptop"
									/>
								</div>
								<div
									v-else-if="
										field.key == 'phoneNumber' || field.key == 'altPhoneNumber'
									"
									class="topDiv"
								>
									<PhoneNumber
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:code="getCountryCode(field)"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										@select-value="updateFieldValue(field, $event)"
										@select-country-code="updateCountryCode(field, $event)"
										@phonevalidation="updatePhoneValidation(field, $event)"
									/>
								</div>
								<div v-else-if="field.controlType == 'checkbox'" class="topDiv">
									<Checkbox
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:values="field.values"
									/>
								</div>
								<div v-else-if="field.controlType == 'textarea'" class="topDiv">
									<Textarea
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										:newObject="newObject"
										:formID="formID"
										:limit="field.limit"
										@loading-status="disableButton = $event"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>
								</div>
								<div
									v-else-if="
										field.controlType == 'location' || field.key == 'city'
									"
									class="topDiv"
								>
									<LocationSearch
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										:formID="formID"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>
								</div>
								<div
									v-else-if="
										field.controlType == 'text' && field.key == 'institute'
									"
									class="topDiv"
								>
									<Selectwithsearch
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:showError="getError(field)"
										:vmodel="getVmodel(field)"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<div
									v-else-if="
										(field.key == 'highlight' && formID == 'experience') ||
										(field.key == 'responsibility' && formID == 'project') ||
										(field.key == 'portfolio' && formID == 'personalDetails')
									"
									class="topDiv"
								>
									<MultipleInput
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:showError="getError(field)"
										:vmodel="getVmodel(field)"
										:fieldVal="field"
										:formID="formID"
										:limit="field.limit"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>
								</div>

								<div
									v-else-if="
										field.controlType == 'text' ||
										field.controlType == 'email' ||
										field.controlType == 'number'
									"
									class="topDiv"
								>
									<InputField
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:showError="getError(field)"
										:vmodel="getVmodel(field)"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>

									<div
										v-if="field.key == 'firstName' && !getError(field)"
										class="position-absolute d-flex perd-name-pos"
									>
										<div
											class="mr-1 d-flex align-items-start"
											@mouseover="showDispTooltip = true"
											@mouseleave="showDispTooltip = false"
										>
											<img
												src="@/assets/newdesign/dashboard/iGreySvg.svg"
												alt=""
											/>
										</div>
										<div v-if="showTooltip" class="candash-name-tooltip">
											<div class="asp-small-txt text-center">
												Trimmed lengthy data for AI resume.
											</div>
										</div>
										<div class="candash-character-left display-no-wrap">
											Display Name :
										</div>
										<div class="candash-character-left ml-1 display-text-break">
											<b>{{ checkFirstName }}</b>
										</div>
									</div>
								</div>

								<div
									v-else-if="field.controlType == 'single_select'"
									class="topDiv"
								>
									<SelectCustom
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:api="field.apiEndpoint"
										:values="field.values"
										:dropdown="field.dropdown"
										:fieldType="field.fieldType"
										:showError="getError(field)"
										:vmodel="getVmodel(field)"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'multi_select'"
									class="topDiv"
								>
									<MultiSelectCustom
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:api="field.apiEndpoint"
										:values="field.values"
										:dropdown="field.dropdown"
										:fieldType="field.fieldType"
										:showError="getError(field)"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'rich_text_box'"
									class="topDiv"
								>
									<CustomQuillEditor
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
										:showError="getError(field)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'boolean'"
									class="topDiv mt-4"
								>
									<Checkbox
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'upload_file'"
									class="topDiv"
								>
									<UploadDocument
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'multi_text'"
									class="topDiv"
								>
									<FormTags
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
										:vmodel="getVmodel(field)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>
								</div>
								<div v-else-if="field.controlType == 'date'" class="topDiv">
									<DateField
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										:format="field.dateTimeFormat"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<template
									v-if="
										touchedFields[field.key] &&
										!validateField(field) &&
										notAMultipleInput(field)
									"
								>
									<div
										class="newInt-required-validation-font mt-1"
										:class="
											(field.controlType == 'textarea' ||
												field.key == 'portfolio') &&
											formID == 'personalDetails'
												? 'perd-error-txt-2'
												: field.controlType == 'textarea'
												? 'perd-error-txt-1'
												: 'perd-error-txt'
										"
										v-if="field.mandatory"
									>
										{{ valText[field.key] }}
									</div>
									<div
										class="newInt-required-validation-font mt-1"
										:class="
											(field.controlType == 'textarea' ||
												field.key == 'portfolio') &&
											formID == 'personalDetails'
												? 'perd-error-txt-2'
												: field.controlType == 'textarea'
												? 'perd-error-txt-1'
												: 'perd-error-txt'
										"
										v-else-if="field.limit > 0"
									>
										{{ valText[field.key] }}
									</div>
								</template>
								<div
									v-else-if="
										field.key == 'profileSummary' && field.limit != null
									"
									class="candash-character-left perd-char-pos"
								>
									{{
										!newObject.profileSummary
											? "300"
											: field.limit - newObject.profileSummary.length
									}}
									characters left
								</div>
							</div>
						</div>
					</div>

					<footer
						v-if="formID == 'personalDetails'"
						class="candash-modal-footer d-flex align-items-center justify-content-end"
					>
						<b-button
							v-if="formType == 'edit'"
							class="candash-cancelBtn mr-4 pointer"
							@click="loading ? '' : $emit('close-modal')"
							>Cancel</b-button
						>

						<div class="position-relative">
							<b-button
								:class="{
									'loader-class-update defaultCursor':
										loading && formType == 'edit',
									'loader-class-save defaultCursor':
										loading && formType != 'edit',
								}"
								class="candash-addBtn"
								@click="loading ? '' : validateForm()"
								:disabled="disableButton"
								>{{
									loading ? "" : formType == "edit" ? "Update" : "Save"
								}}</b-button
							>
							<div v-if="loading" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</footer>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import commonForm from "@/controllers/dashboard/mixin/commonForm";

export default {
	name: "PersonalDetails",
	mixins: [commonForm],
	computed: {
		computedBackdropClass() {
			return this.isOnboardingActive ? "onboarding-modal-backdrop" : "";
		},
		...mapGetters("candidateVUEX", {
			isOnboardingActive: "getIsOnboardingActive",
		}),
	},
};
</script>

<style scoped>
.grid-container {
	display: grid;
	gap: 10px;
	grid-template-columns: repeat(7, 1fr);
	grid-template-rows: auto;
	/* height: 460px; */
}

.grid-item {
	background-color: rgba(255, 255, 255, 0.8);
	padding-left: 20px;
	min-height: 61px;
}

.item1 {
	grid-column: 1; /* Span all 5 columns */
	grid-row: 1 / span 6; /* Span across 5 rows */
	padding-left: 0 !important;
}

.item2 {
	grid-column: 2 / span 3;
	grid-row: 1; /* Span 2 rows */
}

.item3 {
	grid-column: 5 / span 3;
	grid-row: 1;
}

.item4 {
	grid-column: 2 / span 3;
	grid-row: 2;
}

.item6 {
	grid-column: 5 / span 3;
	grid-row: 2;
}

.item8 {
	grid-column: 2 / span 3;
	grid-row: 3;
}
.item10 {
	grid-column: 5 / span 3;
	grid-row: 3;
}
.item11 {
	grid-column: 2 / span 3;
	grid-row: 4;
}
.item12 {
	grid-column: 5 / span 3;
	grid-row: 4;
}
.item13 {
	grid-column: 2 / span 3;
	grid-row: 5;
}
.item14 {
	grid-column: 5 / span 3;
	grid-row: 5;
}

.item15 {
	grid-column: 1 / span 7;
	grid-row: 7;
	/* min-height: 160px; */
	padding-left: 0 !important;
	border-top: 1px solid #e4e7ec;
	border-bottom: 1px solid #e4e7ec;
	padding-block: 20px;
}
.item16 {
	grid-column: 1 / span 7;
	grid-row: 8;
	padding-left: 0 !important;
}

.item17 {
	grid-column: 2 / span 3;
	grid-row: 6;
}

.perd-name-pos {
	left: 29%;
	top: 43px;
	align-items: center;
}
.perd-char-pos {
	padding-left: 16%;
}
.perd-error-txt {
	position: absolute;
	left: 33%;
}
.perd-error-txt-1 {
	position: absolute;
	left: 14%;
}
.perd-error-txt-2 {
	position: absolute;
	left: 16%;
}
</style>
